import React, { useState, useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import {
  listCreateOrderOfBillings,
  getCreateOrderOfBilling,
} from "../../graphql/queries";
import { updateCreateOrderOfBilling } from "../../graphql/mutations";
import fetchItemsNextToken from "../../function/fetchItemsNextTokenZau";
import {
  Card,
  Modal,
  Button,
  Alert,
  Row,
  Col,
  Input,
  notification,
  Statistic,
  Tag,
  Descriptions,
  Collapse,
  Image,
} from "antd";
import { UserOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import "sweetalert2/src/sweetalert2.scss";

import { CSVLink } from "react-csv";

import { DatePicker, Space } from "antd";

import ResizableAntdTable from "resizable-antd-table";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;

const user = JSON.parse(localStorage.getItem("profile"));

const Approver4 = (props) => {
  const [dataAll, setDataAll] = useState([]);
  const [listoforderpayment, setlistoforderpayment] = useState([]);
  const [listoforderpaymentNot, setlistoforderpaymentNot] = useState([]);
  const [listofpaid, setlistoforderpaid] = useState([]);
  const [listofForPayment, setlistofForPayment] = useState([]);
  const [numberOfPaid, setNumberOfPaid] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [checkArray, setCheckedArray] = useState([]);
  const [opData, setOpData] = useState([]);
  const [signature, setSignature] = useState("");
  const [orderpaymentid, setOrderpaymentid] = useState(null);
  const [approved, setApproved] = useState("0");
  const [toSearch, setToSearch] = useState("");
  const [forFilterSearch, setForFilterSearch] = useState([]);
  const [data, setData] = useState([]);
  const [dataList, setDataList] = useState(listoforderpaymentNot);
  const [headers, setheaders] = useState([
    { label: "Name of Applicant", key: "name_of_applicant" },
    { label: "Project Location", key: "project_location" },
    { label: "Billing No", key: "order_payment_no" },
    { label: "Date of Billing Generated", key: "updatedAt" },
    { label: "ORNO", key: "ORNumber" },
    { label: "ORNO Date", key: "OrDate" },
    {
      label: "ANNUAL BUILDING INSPECTION FEES",
      key: "ANNUAL_BUILDING_INSPECTION_FEES",
    },
    {
      label: "ANNUAL BUILDING INSPECTION FEES DUPLICATE",
      key: "ANNUAL_BUILDING_INSPECTION_FEES1",
    },
    {
      label: "ANNUAL ELECTRICAL INSPECTION FEES",
      key: "ANNUAL_ELECTRICAL_INSPECTION_FEES",
    },
    {
      label: "ANNUAL ELECTRICAL INSPECTION FEES DUPLICATE",
      key: "ANNUAL_ELECTRICAL_INSPECTION_FEES1",
    },

    {
      label: "ANNUAL MECHANICAL INSPECTION FEES",
      key: "ANNUAL_MECHANICAL_INSPECTION_FEES",
    },
    {
      label: "ANNUAL MECHANICAL INSPECTION FEES DUPLICATE",
      key: "ANNUAL_MECHANICAL_INSPECTION_FEES1",
    },
    {
      label: "ANNUAL SANITARY/PLUMBING INSPECTION FEES",
      key: "ANNUAL_SANITARYPLUMBING_INSPECTION_FEES",
    },
    {
      label: "ANNUAL SANITARY/PLUMBING INSPECTION FEES DUPLICATE",
      key: "ANNUAL_SANITARYPLUMBING_INSPECTION_FEES1",
    },
    {
      label: "ANNUAL ELECTRONICS INSPECTION FEES",
      key: "ANNUAL_ELECTRONICS_INSPECTION_FEES",
    },
    {
      label: "ANNUAL ELECTRONICS INSPECTION FEES DUPLICATE",
      key: "ANNUAL_ELECTRONICS_INSPECTION_FEES1",
    },
    {
      label: "TOTAL SURCHARGE",
      key: "SURCHARGE",
    },
    {
      label: "TOTAL ADMINISTRATIVE FINE",
      key: "PENALTIES",
    },

    { label: "Total Amount", key: "grand_total_payment_no" },
  ]);

  const [showmodalRemarks, setShowmodalRemarks] = useState(false);
  const [remarksArray, setRemarksArray] = useState([]);
  const [title, setTitle] = useState("List of Approval");
  const [attachmentId, setAttachmentId] = useState([]);
  const [listofdenied, setListofdenied] = useState([]);

  useEffect(() => {
    fetchListofOrderofPaymentsNot();
    const intervalId = setInterval(() => {
      fetchListofOrderofPaymentsNot();
    }, 5000); // Refresh data every 5 seconds

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    fetchListofOrderofPayments();
    const intervalId = setInterval(() => {
      fetchListofOrderofPayments();
    }, 5000); // Refresh data every 5 seconds

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    fetchListofPaid();
    const intervalId = setInterval(() => {
      fetchListofPaid();
    }, 5000); // Refresh data every 5 seconds

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    fetchOrderOfpaymentForPayment();
    const intervalId = setInterval(() => {
      fetchOrderOfpaymentForPayment();
    }, 5000); // Refresh data every 5 seconds

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    fetchListofDenied();
    const intervalId = setInterval(() => {
      fetchListofDenied();
    }, 5000); // Refresh data every 5 seconds

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const fetchListofPaid = async () => {
    const queryData = {
      query: listCreateOrderOfBillings,
      variables: {
        filter: { isDeleted: { notContains: "1" } },
        limit: 1000,
      },
    };

    const a = fetchItemsNextToken(queryData);
    a.then(async (response) => {
      const listofPaid = response.filter((item) => item.OrNumber !== "0");
      setNumberOfPaid(listofPaid);
    });
  };

  const fetchListofDenied = async () => {
    const queryData = {
      query: listCreateOrderOfBillings,
      variables: {
        filter: {
          isDeny: { eq: "2" },
          status: { eq: "15" },
          isDeleted: { ne: "1" },
        },
        limit: 1000,
      },
    };

    const a = fetchItemsNextToken(queryData);
    a.then(async (response) => {
      setListofdenied(
        response.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
      );
    });
  };

  const fetchOrderOfpaymentForPayment = async () => {
    const queryData = {
      query: listCreateOrderOfBillings,
      variables: {
        filter: {
          opStatus: { eq: "1" },
          status: { eq: "3" },
          isDeleted: { ne: "1" },
        },
        limit: 1000,
      },
    };

    const a = fetchItemsNextToken(queryData);
    a.then(async (response) => {
      setlistofForPayment(
        response.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
      );
    });
  };

  const fetchListofOrderofPayments = async () => {
    const queryData = {
      query: listCreateOrderOfBillings,
      variables: {
        filter: {
          opStatus: { eq: "1" },
          status: { eq: "3" },
          isDeleted: { ne: "1" },
        },
        limit: 1000,
      },
    };

    const a = fetchItemsNextToken(queryData);
    a.then(async (response) => {
      setlistoforderpayment(
        response.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
      );
    });
  };

  const fetchListofOrderofPaymentsNot = async () => {
    const queryData = {
      query: listCreateOrderOfBillings,
      variables: {
        filter: {
          opStatus: { eq: "1" },
          status: { eq: "2" },
          isDeleted: { ne: "1" },
        },
        limit: 1000,
      },
    };

    const a = fetchItemsNextToken(queryData);
    a.then(async (response) => {
      setlistoforderpaymentNot(
        response.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
      );
      setForFilterSearch(
        response.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
      );
    });
  };

  // const handleLoadApprovedWithBillingNo = () => {
  //   try {
  //     setApproved("3");
  //     setTitle("List for Payment with Billing Number");
  //     fetchOrderOfpaymentForPayment();
  //     setDataList(listoforderpayment);
  //     setDataAll(listoforderpayment);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleDenied = () => {
    try {
      setTitle("List of Denied");
      fetchOrderOfpaymentForPayment();
      setDataList(listofdenied);
      setDataAll(listofdenied);
    } catch (error) {
      console.log(error);
    }
  };

  const handleLoadApprovedNOBillingNo = () => {
    try {
      setApproved("1");
      setTitle("List of Approved");
      fetchListofOrderofPayments();
      setDataList(listofForPayment);
      setDataAll(listofForPayment);
    } catch (error) {
      console.log(error);
    }
  };

  const handleLoadNotApproved = () => {
    try {
      setApproved("0");
      setTitle("List of Approval");
      fetchListofOrderofPayments();
      setDataList(listoforderpaymentNot);
      setDataAll(listoforderpaymentNot);
    } catch (error) {
      console.log(error);
    }
  };

  // const handleLoadPaid = () => {
  //   try {
  //     fetchListofPaid();
  //     setTitle("List of Paid");
  //     setApproved("2");
  //     setDataList(numberOfPaid);
  //     setlistoforderpaid(numberOfPaid);
  //     setDataAll(numberOfPaid);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  async function handleShowModal(e, data) {
    e.preventDefault();
    console.log(data);
    try {
      setIsModalVisible(true);
      setOrderpaymentid(data.id);
      setSignature(data.status);
      setCheckedArray(JSON.parse(data.Payitem));
      setOpData(data);
      setAttachmentId(JSON.parse(data.locations));
    } catch (error) {
      console.log(error);
    }
  }

  const formatAMPM = (date) => {
    let d = new Date(date);
    let hours = d.getHours();
    let minutes = d.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  };

  function numberWithCommas(x) {
    return x?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const finalSentence = (mySentence) => {
    return mySentence?.replace(/(^\w{1})|(\s+\w{1})/g, (letter) =>
      letter?.toUpperCase()
    );
  };

  const handleApproved = () => {
    Swal.fire({
      title: `Are you sure you want to forward it?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve it!",
    }).then((result) => {
      if (result.isConfirmed) {
        API.graphql(
          graphqlOperation(updateCreateOrderOfBilling, {
            input: {
              id: orderpaymentid,
              Signature1: "1",
              status: "3",
              nameofapprover4: user.fname + " " + user.mname + " " + user.lname,
              signatureDate1: new Date(),
            },
          })
        ).then((res) => {
          if (res) {
            Swal.fire("Success!", ``, "success").then(() => {
              setIsModalVisible(false);
              window.location.reload();
            });
          }
        });
      }
    });
  };

  async function handleRegenerateApplications(e, data) {
    e.preventDefault();
    try {
      Swal.fire({
        title:
          "Do you want to deny the application? May we ask for some details on why you want to deny it?",
        html: `<textarea id="remarks" rows="10" cols="50">`,
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Deny",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          const remarks = Swal.getPopup().querySelector("#remarks").value;
          let a = {
            remarks: remarks,
            date: new Date(),
            deniedBy: user.fname + " " + user.mname + " " + user.lname,
          };
          return await API.graphql(
            graphqlOperation(getCreateOrderOfBilling, {
              id: data.id,
            })
          ).then(async (response) => {
            const jsonResRemarks = JSON.parse(
              response.data.getCreateOrderOfBilling.deniedRemarks
            );
            jsonResRemarks.push(a);
            return await API.graphql(
              graphqlOperation(updateCreateOrderOfBilling, {
                input: {
                  id: response.data.getCreateOrderOfBilling.id,
                  opStatus: "0",
                  isDeny: "1",
                  status: "15",
                  deniedRemarks: JSON.stringify(jsonResRemarks),
                },
              })
            );
          });
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          notification["success"]({
            message: "success",
            description: "Successfully Approved",
          });
          setIsModalVisible(false);
          window.location.reload();
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  async function handleShowRemarks(e, data) {
    e.preventDefault();
    try {
      setShowmodalRemarks(true);
      setRemarksArray(JSON.parse(data.deniedRemarks));
    } catch (error) {
      console.log("remarks array", error);
    }
  }

  async function handleCloseshowRemarks() {
    setCheckedArray([]);
    setShowmodalRemarks(false);
  }

  const SearchValue = (event) => {
    const query = event;
    var updatedList = [...dataList];
    updatedList = updatedList.filter((item) => {
      return (
        item.name_of_applicant.toLowerCase().indexOf(query.toLowerCase()) !== -1
      );
    });
    setDataAll(updatedList);
  };

  const handleResetSearch = (e) => {
    e.preventDefault();
    setToSearch("");
    setDataAll([]);
  };

  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const columns = [
    {
      title: "Name of Applicant",
      dataIndex: "owner",
      key: "owner",
      width: 250,
      render: (text, record) => (
        <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {record.owner}
        </span>
      ),
    },
    {
      title: "Project Activity",
      dataIndex: "project_activity",
      key: "project_activity",
      width: 310,
      render: (text, record) => (
        <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {record.project_activity}
        </span>
      ),
    },
    {
      title: "Date created",
      dataIndex: "date",
      key: "locale",
      width: 150,
      render: (text, record) => (
        <Tag color="cyan" style={{ fontSize: "16px", fontWeight: "normal" }}>
          {month[new Date(record.createdAt).getMonth()]}{" "}
          {new Date(record.createdAt).getDate()}{" "}
          {new Date(record.createdAt).getFullYear()}{" "}
          {formatAMPM(record.createdAt)}
        </Tag>
      ),
    },
    {
      title: "Grand Total",
      dataIndex: "grandTotal",
      key: "grandTotal",
      width: 100,
      render: (text, record) => (
        <Tag color="volcano" style={{ fontSize: "16px", fontWeight: "normal" }}>
          {record.grandTotal
            ? `PHP ${numberWithCommas(record.grandTotal)}`
            : ""}
        </Tag>
      ),
    },

    // {
    //   title: "OR Number/OR DATE",
    //   width: 180,
    //   render: (text, record) => (
    //     <span>
    //       {record.order_payment_no && record.ORNumber ? (
    //         <>
    //           <Tag
    //             color="volcano"
    //             style={{
    //               fontSize: "16px",
    //               fontWeight: "normal",
    //               marginBottom: "10px",
    //             }}
    //           >
    //             OR #: {record.ORNumber}
    //           </Tag>
    //           <br></br>
    //           <Tag
    //             color="cyan"
    //             style={{ fontSize: "16px", fontWeight: "normal" }}
    //           >
    //             ORDATE: {record.OrDate}
    //           </Tag>
    //         </>
    //       ) : null}
    //     </span>
    //   ),
    // },
    {
      title: "Billing Officer",
      dataIndex: "grand_total_payment_no",
      key: "grand_total_payment_no",
      width: 150,
      render: (text, record) => (
        <Tag color="volcano" style={{ fontSize: "16px", fontWeight: "normal" }}>
          {record.billing_officer !== null
            ? finalSentence(record.billing_officer)
            : ""}
        </Tag>
      ),
    },
    {
      title: "Type of Application",
      width: 120,
      align: "center",
      render: (text, record) => (
        <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {record.isGovementInstitution ? (
            <Tag color="volcano">Goverment</Tag>
          ) : record.isNoPaymenItem ? (
            <Tag color="cyan">Amendment</Tag>
          ) : record.doesHaveOldOP ? (
            <Tag color="magenta">(With old order of payment)</Tag>
          ) : null}
        </span>
      ),
    },
    {
      title: "Status",
      width: 450,
      align: "center",
      render: (text, record) => (
        <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {/* {record.isDeny === "2" && record.Signature1 === "0" ? (
            <Button onClick={(e) => handleShowRemarks(e, record)}>
              <Tag color="#f50">Denied</Tag>
            </Button>
          ) : record.opStatus === "1" &&
            record.Signature1 === "0" &&
            record.Signature2 === "0" ? (
            <Button>
              <Tag color="#87d068">For Approval</Tag>
            </Button>
          ) : record.opStatus === "1" &&
            record.Signature1 === "1" &&
            record.Signature2 === "0" &&
            record.order_payment_no === "0" ? (
            <Button>
              <Tag color="#87d068">For Approval</Tag>
            </Button>
          ) : record.opStatus === "1" &&
            record.Signature1 === "1" &&
            record.Signature2 === "1" &&
            record.order_payment_no !== "0" &&
            record.OrNumber === "0" ? (
            <Button>
              <Tag color="#108ee9">For Payment</Tag>
            </Button>
          ) : (
            <Button>
              <Tag color="#2db7f5">Paid</Tag>
            </Button>
          )} */}

          {record.status === "1" ? (
            <Tag color="#87d068">New Application</Tag>
          ) : record.status === "2" ? (
            <Tag color="#87d068">For Recommendation</Tag>
          ) : record.status === "3" ? (
            <Tag color="#87d068">For Approval</Tag>
          ) : record.status === "4" ? (
            <Tag color="#87d068">For Payment </Tag>
          ) : record.status === "5" ? (
            <Tag color="#87d068">Paid</Tag>
          ) : record.status === "15" && record.isDeny === "2" ? (
            <Button onClick={(e) => handleShowRemarks(e, record)}>
              <Tag color="#f50">Denied</Tag>
            </Button>
          ) : null}
        </span>
      ),
    },
    {
      title: "",
      key: "action",
      width: 80,
      render: (text, record) => (
        <>
          {" "}
          <span>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginRight: "10px",
              }}
            >
              <button
                type="primary"
                className="btn btn-warning btn-sm"
                onClick={(e) => handleShowModal(e, record)}
                style={{ marginRight: "10px" }}
              >
                <i className="fa fa-file-text"></i>&nbsp;&nbsp;<b>VIEW</b>
              </button>
              {record.status === "15" && record.isDeny === "2" && (
                <button
                  type="primary"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => handleRegenerateApplications(e, record)}
                >
                  <i className="fa fa-file-text"></i>&nbsp;&nbsp;<b>DENY</b>
                </button>
              )}
              {record.status === "2" && (
                <button
                  type="primary"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => handleRegenerateApplications(e, record)}
                >
                  <i className="fa fa-file-text"></i>&nbsp;&nbsp;<b>DENY</b>
                </button>
              )}
            </div>
          </span>
        </>
      ),
    },
  ];

  return (
    <div>
      <div class="form-row" style={{ marginBottom: "50px" }}>
        <div class="col-4">
          <div onClick={handleLoadNotApproved}>
            <Card
              hoverable
              style={{
                width: "100%",
                borderRadius: "16px",
                boxShadow: "0 0 16px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Statistic
                title="For Recommendation"
                value={listoforderpaymentNot.length}
                valueStyle={{
                  color: "#cf1322",
                }}
                prefix={<UserOutlined />}
              />
            </Card>
          </div>
        </div>
        <div class="col-4">
          <div onClick={handleDenied}>
            <Card
              hoverable
              style={{
                width: "100%",
                borderRadius: "16px",
                boxShadow: "0 0 16px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Statistic
                title="Denied Application"
                value={listofdenied.length}
                valueStyle={{
                  color: "#E7800F",
                }}
                prefix={<UserOutlined />}
                onClick={() => alert("x")}
              />
            </Card>
          </div>
        </div>
        <div class="col-4">
          <div onClick={handleLoadApprovedNOBillingNo}>
            <Card
              hoverable
              style={{
                width: "100%",
                borderRadius: "16px",
                boxShadow: "0 0 16px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Statistic
                title="Approved"
                value={listofForPayment.length}
                valueStyle={{
                  color: "#E7800F",
                }}
                prefix={<UserOutlined />}
                onClick={() => alert("x")}
              />
            </Card>
          </div>
        </div>
        {/* <div class="col-3">
          <div onClick={handleLoadApprovedWithBillingNo}>
            <Card hoverable>
              <Statistic
                title="For Department Head Approval"
                value={listoforderpayment.length}
                valueStyle={{
                  color: "#E7800F",
                }}
                prefix={<UserOutlined />}
                onClick={() => alert("x")}
              />
            </Card>
          </div>
        </div> */}
        {/* <div class="col-4">
          <div onClick={handleLoadPaid}>
          <Card hoverable style={{ width: '100%', borderRadius: '16px', boxShadow: '0 0 16px rgba(0, 0, 0, 0.1)' }}>
              <Statistic
                title="List of Paid"
                value={numberOfPaid.length}
                valueStyle={{
                  color: "#E7800F",
                }}
                prefix={<UserOutlined />}
                onClick={() => alert("x")}
              />
            </Card>
          </div>
        </div> */}
      </div>

      <div className="d-flex justify-content-start">
        <div className="p-2 col-example text-left">
          <div className="p-2 col-example text-left">
            <h2>{title}</h2>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-start">
        <div className="p-2 col-example text-left">
          <Input
            style={{ width: 320, marginBottom: "20px" }}
            onChange={(e) => SearchValue(e.target.value)}
            placeholder="Search...."
          />
          <button
            type="button"
            style={{ width: 50, marginLeft: "10px" }}
            className="btn btn-warning btn-sm"
            onClick={(e) => handleResetSearch(e)}
          >
            <i className="fa fa-refresh" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <ResizableAntdTable
        bordered={true}
        columns={columns}
        dataSource={dataAll}
        pagination={{ pageSize: 50 }}
      />

      <Modal
        visible={isModalVisible}
        width={1200}
        closable={false}
        footer={[
          <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button onClick={() => setIsModalVisible(false)} danger>
                Close
              </Button>
              {signature === "2" && opData.lcNo !== "-" && opData.lcNo !=="" ? (
                <Button type="primary" onClick={(e) => handleApproved(e)}>
                  Approve
                </Button>
              ) : null}
            </div>
          </>,
        ]}
      >
        <Row>
          <Col xs={24} xl={24}>
            <Card
              title={
                !opData?.isGovementInstitution &&
                !opData?.isNoPaymenItem &&
                !opData?.doesHaveOldOP ? (
                  <Alert
                    style={{ fontWeight: "bold", fontSize: "16px" }}
                    message={`Billing Number: ${
                      opData.order_payment_no !== "0"
                        ? opData.order_payment_no
                        : "Not Yet Approved"
                    }`}
                    type="info"
                  />
                ) : null
              }
            >
              {opData?.isGovementInstitution && (
                <Card>This application is for goverment Institution</Card>
              )}

              {opData?.isNoPaymenItem && (
                <Card>This application is for Ammendment</Card>
              )}

              <br></br>
              <Collapse size="large" defaultActiveKey={["1", "2"]}>
                {opData?.typeofapplication === "COE" ? (
                  <>
                    <Panel
                      header={`Locational Details - CE No. ${opData?.ceNo}`}
                      key="1"
                    >
                      <Descriptions layout="vertical" size="middle" bordered>
                        <Descriptions.Item label="Name of Applicant">
                          <b>
                            {opData && String(opData.owner).toLocaleUpperCase()}
                          </b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Project Activity">
                          <b>
                            {opData &&
                              String(opData.project_activity).toUpperCase()}
                          </b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Project Location">
                          <b>
                            {opData?.address
                              ? opData?.address
                              : opData &&
                                `${opData.lot_no}, ${opData.blk_no}, ${opData.location_street}, ${opData.location_barangay}, ${opData.location_district}, QUEZON CITY`}
                          </b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Floor Area (sq.m)">
                          <b>
                            {opData && String(opData.floor_area).toUpperCase()}
                          </b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Lot Area (sq.m)">
                          <b>
                            {opData && String(opData.lot_area).toUpperCase()}
                          </b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Application No">
                          <b>
                            {opData &&
                              String(opData.application_no).toUpperCase()}
                          </b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Postal Address">
                          <b>{String(opData.postalAddress)}</b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Prescriptive Notation:">
                          <b>
                            {opData &&
                              String(
                                opData.evaluation_facts_extended
                              ).toUpperCase()}
                          </b>
                        </Descriptions.Item>
                      </Descriptions>
                    </Panel>

                    {!opData?.isGovementInstitution &&
                      !opData?.isNoPaymenItem &&
                      !opData?.doesHaveOldOP && (
                        <Panel header="Order of Payment Details" key="2">
                          <Card type="inner" style={{ marginTop: "10px" }}>
                            <Row gutter={[8, 16]}>
                              <table className="table-responsive">
                                <table className="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th scope="col">Payitem</th>
                                      <th scope="col">FEES</th>
                                      <th scope="col">TOTAL</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {checkArray?.map((x, i) => (
                                      <tr>
                                        <td>{checkArray[i]["paymentitem"]}</td>
                                        <td>{checkArray[i]["fees"]}</td>
                                        <td>{checkArray[i]["total"]}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </table>
                            </Row>
                          </Card>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              marginTop: "30px",
                            }}
                          >
                            <Row gutter={[8, 24]}>
                              <Col span={24}>
                                <span>
                                  <label
                                    className="loginInput-label"
                                    htmlFor="fname"
                                  >
                                    GRAND TOTAL:
                                  </label>
                                  <Input
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "20px",
                                      width: "80%",
                                      display: "flex",
                                      justifyContent: "",
                                    }}
                                    value={`Php ${opData.grandTotal}`}
                                  />
                                </span>
                              </Col>
                            </Row>
                          </div>
                        </Panel>
                      )}
                  </>
                ) : (
                  <>
                    <Panel header="Locational Details" key="1">
                      <Descriptions layout="vertical" size="middle" bordered>
                        <Descriptions.Item label="Name of Applicant">
                          <b>
                            {opData && String(opData.owner).toLocaleUpperCase()}
                          </b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Project Activity">
                          <b>
                            {opData &&
                              String(opData.project_activity).toUpperCase()}
                          </b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Project Location">
                          <b>
                            {opData &&
                              `${opData.lot_no}, ${opData.blk_no}, ${opData.location_street}, ${opData.location_barangay}, ${opData.location_district}, QUEZON CITY`}
                          </b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Floor Area (sq.m)">
                          <b>
                            {opData && String(opData.floor_area).toUpperCase()}
                          </b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Lot Area (sq.m)">
                          <b>
                            {opData && String(opData.lot_area).toUpperCase()}
                          </b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Application No">
                          <b>
                            {opData &&
                              String(opData.application_no).toUpperCase()}
                          </b>
                        </Descriptions.Item>
                        <Descriptions.Item label="District">
                          <b>
                            {opData &&
                              String(opData.location_district).toUpperCase()}
                          </b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Zone Classifications">
                          <b>
                            {opData &&
                              String(opData.zone_classification).toUpperCase()}
                          </b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Evaluation of Facts:">
                          <b>
                            {opData &&
                              String(opData.evaluation_facts).toUpperCase()}
                          </b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Prescriptive Notation:">
                          <b>
                            {opData &&
                              String(
                                opData.evaluation_facts_extended
                              ).toUpperCase()}
                          </b>
                        </Descriptions.Item>
                      </Descriptions>
                    </Panel>

                    {!opData?.isGovementInstitution &&
                      !opData?.isNoPaymenItem &&
                      !opData?.doesHaveOldOP && (
                        <Panel header="Order of Payment Details" key="2">
                          <Card type="inner" style={{ marginTop: "10px" }}>
                            <Row gutter={[8, 16]}>
                              <table className="table-responsive">
                                <table className="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th scope="col">Payitem</th>
                                      <th scope="col">FEES</th>
                                      <th scope="col">TOTAL</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {checkArray?.map((x, i) => (
                                      <tr>
                                        <td>{checkArray[i]["paymentitem"]}</td>
                                        <td>{checkArray[i]["fees"]}</td>
                                        <td>{checkArray[i]["total"]}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </table>
                            </Row>
                          </Card>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              marginTop: "30px",
                            }}
                          >
                            <Row gutter={[8, 24]}>
                              <Col span={24}>
                                <span>
                                  <label
                                    className="loginInput-label"
                                    htmlFor="fname"
                                  >
                                    GRAND TOTAL:
                                  </label>
                                  <Input
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "20px",
                                      width: "80%",
                                      display: "flex",
                                      justifyContent: "",
                                    }}
                                    value={`Php ${opData.grandTotal}`}
                                  />
                                </span>
                              </Col>
                            </Row>
                          </div>
                        </Panel>
                      )}
                    <Panel header="Attachment" key="3">
                      {" "}
                      <Card type="inner" style={{ marginTop: "10px" }}>
                        <Row gutter={[8, 16]}>
                          <table className="table-responsive">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th scope="col">Files</th>
                                </tr>
                              </thead>
                              <tbody>
                                {attachmentId?.map((x, i) => (
                                  <tr key={i}>
                                    <td>
                                      <Image width={100} height={100} src={x} />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </table>
                        </Row>
                      </Card>
                    </Panel>
                  </>
                )}
              </Collapse>
            </Card>
          </Col>
        </Row>
      </Modal>
      <Modal
        title="Things to do"
        centered
        width={1000}
        visible={showmodalRemarks}
        closable={false}
        footer={[
          <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button onClick={handleCloseshowRemarks} danger>
                Close
              </Button>
            </div>
          </>,
        ]}
      >
        <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Remarks</th>
              <th scope="col">Date</th>
              <th scope="col">Remarks By</th>
            </tr>
          </thead>
          <tbody>
            {remarksArray?.map((item, i) => (
              <tr key={i}>
                <th scope="row">{i + 1}</th>
                <td>{item.remarks.toLocaleUpperCase()}</td>
                <td>
                  {new Date(item.date).toLocaleDateString("en-US") +
                    " " +
                    new Date(item.date).toLocaleTimeString("en-US")}
                </td>
                <td>{item.deniedBy}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Modal>
    </div>
  );
};

export default Approver4;
